var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("最新情報")]),_c('p',[_vm._v("コンテンツ内容をここに")])])
}]

export { render, staticRenderFns }